import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LogoutComponent} from './authentication/pages/logout/logout.component';
import {AuthorizeComponent} from './authentication/pages/authorize/authorize.component';
import {AuthenticationGuard} from './authentication/guards/authentication.guard';
import {PageNotFoundComponent} from './authentication/pages/page-not-found/page-not-found.component';
import {AccountSettingsComponent} from './authentication/pages/account-settings/account-settings.component';
import {GenericErrorComponent} from './authentication/pages/generic-error/generic-error.component';
import {InvalidVerificationComponent} from './authentication/pages/invalid-verification/invalid-verification.component';
import {DavinciLoggedInGuard} from './authentication/guards/DavinciLoggedInGuard';
import {DavinciLoginComponent} from './davinci/davinci-login/davinci-login.component';
import {DavinciChallengeComponent} from './davinci/davinci-challenge/davinci-challenge.component';
import {DavinciManageAccountComponent} from './davinci/davinci-manage-account/davinci-manage-account.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: DavinciLoginComponent, canActivate: [DavinciLoggedInGuard] },
  { path: 'logout', component: LogoutComponent },
  {
    path: 'register',
    component: DavinciLoginComponent,
    data: { flowAction: 'register' },
    canActivate: [DavinciLoggedInGuard]
  },
  {
    path: 'confirm-account',
    component: DavinciLoginComponent,
    data: { flowAction: 'confirmAccount' }, // Updated to use Davinci flow
    // canActivate: [DavinciLoggedInGuard]
  },
  {
    path: 'reset',
    component: DavinciLoginComponent,
    data: { flowAction: 'reset' },
    canActivate: [DavinciLoggedInGuard]
  },
  { path: 'challenge', component: DavinciChallengeComponent, canActivate: [DavinciLoggedInGuard] },

  // Legacy redirects
  { path: 'manage-account', redirectTo: '/settings/account-summary', pathMatch: 'full' },
  { path: 'settings', redirectTo: '/settings/account-summary', pathMatch: 'full' },
  { path: 'settings/ownership', redirectTo: '/settings/account-summary', pathMatch: 'full' },

  // VSE Settings URLs - parameterized for deep-linking
  // Supported sections: account-summary,
  // security, {change-password, change-username} -> login-info, communication-preferences, contact-information
  { path: 'settings/:section', component: DavinciManageAccountComponent, canActivate: [AuthenticationGuard] },

  { path: 'authorize', component: AuthorizeComponent },
  { path: 'account-settings', component: AccountSettingsComponent, canActivate: [AuthenticationGuard] },
  {
    path: 'verify-email',
    component: DavinciLoginComponent,
    data: { flowAction: 'verifyEmail' }, // Updated to use Davinci flow
    canActivate: [AuthenticationGuard]
  },
  { path: 'verify-phone',
    component: DavinciLoginComponent,
    data: { flowAction: 'verifyPhone' }, // Updated to use Davinci flow
    canActivate: [AuthenticationGuard]
  },
  { path: 'error', component: GenericErrorComponent },
  { path: 'invalid-verification',
    component: InvalidVerificationComponent,
    data: { flowAction: 'invalidVerification' } }, // flowAction: invalidVerification
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
